var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 434.18 359.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0092e9;}.cls-2{fill:#009ffa;}.cls-3{fill:#00011b;}.cls-4{fill:#004a83;}.cls-5{fill:#cbddfe;}.cls-6{fill:#fab98f;}.cls-7{fill:#fa9d68;}.cls-8{fill:#78a2ff;}.cls-9{fill:#facfa1;}.cls-10{fill:#fa9985;}.cls-11{fill:#fbfcfe;}.cls-12{fill:#c8ddfe;}.cls-13{fill:#fabc8a;}.cls-14{fill:#a3d9fe;}.cls-15{fill:#ff0c2a;}.cls-16{fill:#930005;}.cls-17{fill:#d9e3fe;}.cls-18{fill:#aed5fe;}.cls-19{fill:#f5fefe;}.cls-20{fill:#d4ecff;}.cls-21{fill:#feb500;}.cls-22{fill:#fee100;}.cls-23{fill:#fedb00;}.cls-24{fill:#fe9700;}.cls-25{fill:#0042d4;}.cls-26{font-size:86.29px;fill:#0660f0;font-family:Quicksand-Bold, Quicksand Bold;font-weight:700;}.cls-27{fill:#35a6ec;}.cls-28{fill:#ff9b03;}.cls-29{fill:#ffe703;}.cls-30{fill:#009aff;}.cls-31{fill:#00b4ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 212.18,
    cy: 161.12,
    r: 151.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 250.28,
    cy: 227.19,
    r: 102.21,
    transform: "translate(-125.45 177.44) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M210.77,285.29l-16,8.37A43.56,43.56,0,0,0,173,320.27l-17.95,62.6a21.25,21.25,0,0,0,10.67,24.75l16.06,8.31h66.94l9.7-119.43",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M288,285.29l16.05,8.37a43.56,43.56,0,0,1,21.72,26.61l17.95,62.6a21.26,21.26,0,0,1-10.67,24.75L317,415.93H225.89L240.36,296.5",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M229.75,270.91s-7.65,1.7-19,14.38l1.5,31,10.12,3.55-7.18,6.66s14.19,41.24,35.06,51.06c.13-55.35-1.54-81.11-1.54-81.11",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M270,270.91s7.65,1.7,19,14.38l-1.49,31-10.13,3.55,7.18,6.66s-14.19,41.24-35.06,51.06C249.3,322.26,251,296.5,251,296.5",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M225.89,275.49s-4.37,52.33,24.38,102.12l.87-86.91Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M275.52,275.49s3.5,52.33-25.25,102.12l-2.68-88.31Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 253.31,
    cy: 155.91,
    r: 13.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 291.41,
    cy: 221.99,
    r: 9.01,
    transform: "translate(-109.72 205) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 208.58,
    cy: 221.99,
    r: 9.01,
    transform: "translate(-83.37 -12.45) rotate(-13.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M191.35,222a5.21,5.21,0,1,0,5.21-5.2A5.2,5.2,0,0,0,191.35,222Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.58,
    cy: 221.99,
    r: 14.51,
    transform: "translate(-83.28 -12.59) rotate(-13.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 165.14,
    y: 139.4,
    width: 9.56,
    height: 32.52,
    rx: 3.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "233.63 187.16 191.65 187.16 191.65 216.37 212.64 224.62 233.63 216.98 233.63 187.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M292.47,179.08H209v51h.08c-.05.84-.08,1.68-.08,2.54a41.74,41.74,0,0,0,83.47,0c0-.86,0-1.7-.09-2.54h.09Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.56,225.83a1.9,1.9,0,0,1-1.89-1.74,4.6,4.6,0,0,0-9.17,0,1.9,1.9,0,0,1-3.79-.32,8.41,8.41,0,0,1,16.75,0,1.9,1.9,0,0,1-1.73,2Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,225.83a1.91,1.91,0,0,1-1.89-1.74,4.6,4.6,0,0,0-9.17,0,1.9,1.9,0,0,1-3.79-.32,8.41,8.41,0,0,1,16.75,0,1.9,1.9,0,0,1-1.73,2Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 207.31,
    y: 148.11,
    width: 10.64,
    height: 22.31,
    rx: 5.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M271.49,241.1a.93.93,0,0,0-.7-.31H230.67a1,1,0,0,0-.95,1,21.09,21.09,0,0,0,42,0A1,1,0,0,0,271.49,241.1Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.67,241.74a20.13,20.13,0,0,0,40.12,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M233.84,251h33.78a20,20,0,0,0,3.17-9.21H230.67A20.16,20.16,0,0,0,233.84,251Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M270,245.68a18.94,18.94,0,0,0,.75-3.94H230.67a20.08,20.08,0,0,0,.86,4.27A50,50,0,0,1,270,245.68Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M286,191.37s-7.82,18.14-34.88,19.49l5.5-8.9s-22.31,8.77-36.44-.85l6.58-4.38s-7.76-.6-10.26-5c10.45-6.57,31.07-9.08,31.07-9.08",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,227.56s5.83-4.21,6.39-22.14l-1.68-4.48,2.81-9.25s9,3.36,15.13,3.92L226,199.82s19.89,4.48,37-3.09l-5.89,9.81s17.11-1.44,28.88-15.17l4.22,8.21-2,5s-1.36,17.1,4.23,23c0,0,11.67-29.26-.6-50.74,0,0-2.45-14.89-39.21-24.92-30.84-8.4-43.66-8.4-43.66-8.4s-5.37,15.41,3.87,21.85L200,162.55s-.74,13.73,9,16.53h-9s.93,7.85,6.25,9.95C206.22,189,204.38,204.73,209,227.56Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "208.83 213.81 212.86 224.62 200.58 224.62 208.83 213.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "216.43 213.81 212.4 224.62 224.69 224.62 216.43 213.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "202.66 224.62 223.41 224.62 217.26 236.23 208.83 236.23 202.66 224.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M254.53,279.89l8.2,18.34s12.36-10.19,12.85-22.74l-3.86-4.58A69.39,69.39,0,0,1,254.53,279.89Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M246.93,279.89l-8.2,18.34S226.37,288,225.89,275.49l3.86-4.58A69.21,69.21,0,0,0,246.93,279.89Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M251.14,302.31l-.87,75.3s-4.8-6.25-9.15-17.67c0,0-7-27.22,5.81-57.63Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M251,302.31l-4,45.85,3.34,29.45a121.68,121.68,0,0,0,9.85-20s7.86-24.87-5-55.28Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M240.83,260.11c-36.23,0-39.89-27.64-39.93-27.91a1.93,1.93,0,0,1,3.84-.46c.13,1,3.4,24.5,36.09,24.5a1.94,1.94,0,0,1,0,3.87Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M249.6,261.67h-6.23a3.26,3.26,0,0,1-3.26-3.26h0a3.26,3.26,0,0,1,3.26-3.27h6.23a3.26,3.26,0,0,1,3.26,3.27h0A3.26,3.26,0,0,1,249.6,261.67Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 129.81,
    y: 259.16,
    width: 159.18,
    height: 95.36,
    rx: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 249.43,
    cy: 369.91,
    r: 14.15,
    transform: "translate(-226.61 218.64) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 249.43,
    cy: 369.91,
    r: 12.23,
    transform: "translate(-216.57 177.52) rotate(-39.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M129.9,354.52H289.07a0,0,0,0,1,0,0v1.16a4,4,0,0,1-4,4H133.91a4,4,0,0,1-4-4v-1.16A0,0,0,0,1,129.9,354.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.78,212.74a2.52,2.52,0,0,1-1.86-.82c-.22-.24-4.77-4.91-15.46-4.67a2.5,2.5,0,0,1-.13-5c13.22-.36,19.07,6.05,19.31,6.33a2.49,2.49,0,0,1-1.86,4.16Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,212.74a2.5,2.5,0,0,0,1.85-.82c.23-.24,4.78-4.91,15.47-4.67a2.5,2.5,0,0,0,.13-5c-13.22-.36-19.07,6.05-19.31,6.33a2.49,2.49,0,0,0,1.86,4.16Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M420,166.36H357.73c-17.59,0-31.94,14.82-30.55,32.36A29.92,29.92,0,0,0,340.13,221a.08.08,0,0,1,0,0v19.07a.06.06,0,0,0,.09,0l17.43-13.9h61.69c16.36,0,30.21-12.82,30.63-29.17A30,30,0,0,0,420,166.36Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M407.19,191.13H349.25a5.62,5.62,0,0,1-5.6-5.6h0a5.62,5.62,0,0,1,5.6-5.6h57.94a5.62,5.62,0,0,1,5.6,5.6h0A5.62,5.62,0,0,1,407.19,191.13Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M386.85,200.12H346.26a1.7,1.7,0,0,1-1.69-1.7h0a1.7,1.7,0,0,1,1.69-1.69h40.59a1.7,1.7,0,0,1,1.69,1.69h0A1.7,1.7,0,0,1,386.85,200.12Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M407.7,200.12h-9.34a1.7,1.7,0,0,1-1.69-1.7h0a1.7,1.7,0,0,1,1.69-1.69h9.34a1.7,1.7,0,0,1,1.69,1.69h0A1.7,1.7,0,0,1,407.7,200.12Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M438.44,200.12H415.83a1.7,1.7,0,0,1-1.69-1.7h0a1.7,1.7,0,0,1,1.69-1.69h22.61a1.7,1.7,0,0,1,1.69,1.69h0A1.7,1.7,0,0,1,438.44,200.12Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M355.86,207.17h-9.34a1.7,1.7,0,0,1-1.7-1.69h0a1.7,1.7,0,0,1,1.7-1.69h9.34a1.69,1.69,0,0,1,1.69,1.69h0A1.69,1.69,0,0,1,355.86,207.17Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M403.7,217.77h-9.34a1.69,1.69,0,0,1-1.69-1.69h0a1.69,1.69,0,0,1,1.69-1.69h9.34a1.69,1.69,0,0,1,1.69,1.69h0A1.69,1.69,0,0,1,403.7,217.77Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M386.6,207.17H364a1.69,1.69,0,0,1-1.69-1.69h0a1.69,1.69,0,0,1,1.69-1.69H386.6a1.69,1.69,0,0,1,1.69,1.69h0A1.69,1.69,0,0,1,386.6,207.17Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M386.6,217.77H364a1.69,1.69,0,0,1-1.69-1.69h0a1.69,1.69,0,0,1,1.69-1.69H386.6a1.69,1.69,0,0,1,1.69,1.69h0A1.69,1.69,0,0,1,386.6,217.77Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M96.59,211.69H147.3c14.32,0,26,12.06,24.87,26.34a24.37,24.37,0,0,1-10.54,18.17,0,0,0,0,0,0,0v15.52s-.05.06-.07,0l-14.2-11.32H97.14c-13.31,0-24.59-10.43-24.93-23.74A24.39,24.39,0,0,1,96.59,211.69Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M107.05,231.85h47.16a4.57,4.57,0,0,0,4.56-4.56h0a4.58,4.58,0,0,0-4.56-4.56H107.05a4.58,4.58,0,0,0-4.56,4.56h0A4.57,4.57,0,0,0,107.05,231.85Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M123.6,239.17h33a1.38,1.38,0,0,0,1.38-1.38h0a1.38,1.38,0,0,0-1.38-1.38h-33a1.38,1.38,0,0,0-1.38,1.38h0A1.38,1.38,0,0,0,123.6,239.17Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M106.63,239.17h7.6a1.38,1.38,0,0,0,1.38-1.38h0a1.38,1.38,0,0,0-1.38-1.38h-7.6a1.38,1.38,0,0,0-1.37,1.38h0A1.38,1.38,0,0,0,106.63,239.17Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M81.61,239.17H100a1.38,1.38,0,0,0,1.37-1.38h0a1.38,1.38,0,0,0-1.37-1.38H81.61a1.38,1.38,0,0,0-1.38,1.38h0A1.38,1.38,0,0,0,81.61,239.17Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M148.83,244.91h7.6a1.38,1.38,0,0,0,1.38-1.37h0a1.38,1.38,0,0,0-1.38-1.38h-7.6a1.37,1.37,0,0,0-1.37,1.38h0A1.37,1.37,0,0,0,148.83,244.91Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M109.88,253.54h7.61a1.38,1.38,0,0,0,1.37-1.38h0a1.38,1.38,0,0,0-1.37-1.38h-7.61a1.38,1.38,0,0,0-1.37,1.38h0A1.38,1.38,0,0,0,109.88,253.54Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M123.81,244.91h18.41a1.38,1.38,0,0,0,1.37-1.37h0a1.38,1.38,0,0,0-1.37-1.38H123.81a1.38,1.38,0,0,0-1.38,1.38h0A1.38,1.38,0,0,0,123.81,244.91Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M123.81,253.54h18.41a1.38,1.38,0,0,0,1.37-1.38h0a1.38,1.38,0,0,0-1.37-1.38H123.81a1.38,1.38,0,0,0-1.38,1.38h0A1.38,1.38,0,0,0,123.81,253.54Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 326.36,
    cy: 120.15,
    r: 42.23,
    transform: "translate(92.63 341.61) rotate(-75.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M309.55,92a4,4,0,1,1-4-4A4,4,0,0,1,309.55,92Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 312.36,
    cy: 77.58,
    r: 4.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M313,87.43a1.71,1.71,0,1,1-1.71-1.71A1.72,1.72,0,0,1,313,87.43Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M355.32,117.08a1.36,1.36,0,0,0-1-.43h-56a1.32,1.32,0,0,0-1.32,1.44,29.41,29.41,0,0,0,58.6,0A1.34,1.34,0,0,0,355.32,117.08Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.38,118a28.08,28.08,0,0,0,56,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M302.8,130.82h47.12A28.11,28.11,0,0,0,354.34,118h-56A27.88,27.88,0,0,0,302.8,130.82Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M353.29,123.48a28.45,28.45,0,0,0,1-5.5h-56a28,28,0,0,0,1.19,6A69.65,69.65,0,0,1,353.29,123.48Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.47,109.21a1.9,1.9,0,0,1-1.89-1.74,4.6,4.6,0,0,0-9.17,0,1.9,1.9,0,1,1-3.79-.33,8.41,8.41,0,0,1,16.75,0,1.91,1.91,0,0,1-1.74,2Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.21,109.21a1.91,1.91,0,0,1-1.9-1.74,4.6,4.6,0,0,0-9.17,0,1.9,1.9,0,0,1-3.79-.33,8.41,8.41,0,0,1,16.75,0,1.89,1.89,0,0,1-1.73,2Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M422.83,263.34H333.6a17.49,17.49,0,0,0-5.22,34.18v10.62l9.82-9.83h84.63a17.49,17.49,0,1,0,0-35Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "297.65 207.27 300.06 212.16 305.46 212.95 301.55 216.75 302.47 222.13 297.65 219.59 292.82 222.13 293.74 216.75 289.83 212.95 295.23 212.16 297.65 207.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "318.65 207.27 321.07 212.16 326.46 212.95 322.56 216.75 323.48 222.13 318.65 219.59 313.82 222.13 314.75 216.75 310.84 212.95 316.24 212.16 318.65 207.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "339.66 207.27 342.07 212.16 347.47 212.95 343.56 216.75 344.49 222.13 339.66 219.59 334.83 222.13 335.75 216.75 331.85 212.95 337.25 212.16 339.66 207.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "360.67 207.27 363.08 212.16 368.48 212.95 364.57 216.75 365.49 222.13 360.67 219.59 355.84 222.13 356.76 216.75 352.85 212.95 358.25 212.16 360.67 207.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "381.67 207.27 384.08 212.16 389.48 212.95 385.58 216.75 386.5 222.13 381.67 219.59 376.84 222.13 377.76 216.75 373.86 212.95 379.26 212.16 381.67 207.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M186.27,151.88a42.72,42.72,0,1,0-33.71,41.72l12.18,12.17V188.94A42.66,42.66,0,0,0,186.27,151.88Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M166,318.07a47.1,47.1,0,1,0-47.1,47.1,47.6,47.6,0,0,0,9.91-1.05l13.43,13.43V359A47.06,47.06,0,0,0,166,318.07Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(59.63 282.85)"
  }, "?"), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M367.49,145a14.14,14.14,0,1,1,14.13,14.14,14.53,14.53,0,0,1-3-.32l-4,4v-5.57A14.13,14.13,0,0,1,367.49,145Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M379,153.37a2.51,2.51,0,0,1-1.77-.73l-4.07-4.07a2.5,2.5,0,1,1,3.53-3.54l2.31,2.31,7.58-7.58a2.5,2.5,0,1,1,3.53,3.54l-9.34,9.34A2.51,2.51,0,0,1,379,153.37Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 105.41,
    cy: 67.63,
    r: 9.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M143.51,145.69h0a15.61,15.61,0,0,1,15.61,15.61V172a9.61,9.61,0,0,1-9.61,9.61h-12a9.61,9.61,0,0,1-9.61-9.61V161.3A15.6,15.6,0,0,1,143.51,145.69Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 171.11,
    cy: 109.56,
    r: 21.61,
    transform: "translate(-66.81 6.66) rotate(-22.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M162.5,95.14a2.05,2.05,0,1,1-2.05-2A2,2,0,0,1,162.5,95.14Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M185.49,121.59a2.05,2.05,0,1,1-2.05-2A2.05,2.05,0,0,1,185.49,121.59Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 125.28,
    cy: 26.74,
    r: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M185.92,108a.67.67,0,0,0-.5-.22H156.79a.68.68,0,0,0-.5.22.71.71,0,0,0-.18.52,15.05,15.05,0,0,0,30,0A.67.67,0,0,0,185.92,108Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.79,108.45a14.37,14.37,0,0,0,28.63,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M159.05,115h24.11a14.18,14.18,0,0,0,2.26-6.57H156.79A14.41,14.41,0,0,0,159.05,115Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M184.89,111.27a13.91,13.91,0,0,0,.53-2.82H156.79a14,14,0,0,0,.61,3A35.65,35.65,0,0,1,184.89,111.27Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.07,104a1,1,0,0,1-1-.89,2.35,2.35,0,0,0-4.69,0,1,1,0,0,1-1.94-.16,4.3,4.3,0,0,1,8.57,0,1,1,0,0,1-.89,1Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.77,104a1,1,0,0,1-1-.89,2.36,2.36,0,0,0-4.7,0,1,1,0,0,1-1.05.89,1,1,0,0,1-.89-1,4.3,4.3,0,0,1,8.57,0,1,1,0,0,1-.88,1Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M398.63,132.4a24.08,24.08,0,1,1,19,23.54l-6.87,6.87v-9.5A24,24,0,0,1,398.63,132.4Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M438.42,135.68v-6.51h-3.79a12.19,12.19,0,0,0-1.18-2.89l2.67-2.67-4.61-4.6-2.65,2.65a12.17,12.17,0,0,0-2.9-1.21v-3.74h-6.51v3.74a12.17,12.17,0,0,0-2.9,1.21L413.9,119l-4.61,4.6,2.67,2.67a12.19,12.19,0,0,0-1.18,2.89H407v6.51h3.82a12.27,12.27,0,0,0,1.19,2.84l-2.71,2.71,4.61,4.61,2.73-2.73a11.87,11.87,0,0,0,2.82,1.16v3.87H426v-3.87a11.87,11.87,0,0,0,2.82-1.16l2.73,2.73,4.61-4.61-2.71-2.71a12.27,12.27,0,0,0,1.19-2.84Zm-15.72,3.83a7.15,7.15,0,1,1,7.15-7.15A7.15,7.15,0,0,1,422.7,139.51Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M96.55,174.92a24.09,24.09,0,1,0-19,23.54l6.87,6.87v-9.5A24.06,24.06,0,0,0,96.55,174.92Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M80,158.8H64.94a1.7,1.7,0,0,0-1.7,1.69V190a1.7,1.7,0,0,0,1.7,1.7H80a1.69,1.69,0,0,0,1.69-1.7V160.49A1.69,1.69,0,0,0,80,158.8Zm-7.64,32a1.76,1.76,0,1,1,1.76-1.76A1.76,1.76,0,0,1,72.36,190.84Zm7.3-5.79a1.31,1.31,0,0,1-1.32,1.33H66.6a1.31,1.31,0,0,1-1.32-1.33v-23a1.31,1.31,0,0,1,1.32-1.32H78.34a1.31,1.31,0,0,1,1.32,1.32Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 405.74,
    y: 235.33,
    width: 5.35,
    height: 10.08,
    transform: "translate(405.34 646.9) rotate(-124.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M384.54,256.91h0a4.19,4.19,0,0,0,5.83,1.06l16-11.11a4.19,4.19,0,0,0,1.06-5.82h0a4.19,4.19,0,0,0-5.82-1.06l-16,11.11A4.19,4.19,0,0,0,384.54,256.91Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 428.64,
    cy: 226.36,
    r: 21.37,
    transform: "translate(-93.8 140.63) rotate(-25.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M419.35,213a16.31,16.31,0,1,0,22.7,4.12A16.32,16.32,0,0,0,419.35,213Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M390.18,81.63v6.28h-6.29a.66.66,0,0,0,0,1.31h6.29v6.29a.66.66,0,0,0,1.31,0V89.22h6.28a.66.66,0,1,0,0-1.31h-6.28V81.63a.66.66,0,1,0-1.31,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M450.82,145v2.87H448a.3.3,0,1,0,0,.6h2.87v2.87a.3.3,0,0,0,.3.3.29.29,0,0,0,.3-.3v-2.87h2.88a.3.3,0,0,0,0-.6h-2.88V145a.29.29,0,0,0-.3-.3A.3.3,0,0,0,450.82,145Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M401.23,326.23v2.88h-2.87a.29.29,0,0,0-.3.3.3.3,0,0,0,.3.3h2.87v2.87a.3.3,0,1,0,.6,0v-2.87h2.87a.3.3,0,0,0,.3-.3.29.29,0,0,0-.3-.3h-2.87v-2.88a.3.3,0,0,0-.6,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M380.87,369.74v2.88H378a.3.3,0,1,0,0,.59h2.87v2.88a.3.3,0,0,0,.6,0v-2.88h2.87a.3.3,0,1,0,0-.59h-2.87v-2.88a.3.3,0,0,0-.6,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M460.8,168.23V177H452a.91.91,0,1,0,0,1.82h8.77v8.76a.91.91,0,1,0,1.81,0v-8.76h8.77a.91.91,0,0,0,0-1.82h-8.77v-8.76a.91.91,0,1,0-1.81,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M391.76,303.21V312H383a.91.91,0,1,0,0,1.81h8.76v8.77a.91.91,0,1,0,1.82,0v-8.77h8.77a.91.91,0,0,0,0-1.81h-8.77v-8.77a.91.91,0,0,0-1.82,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M132.36,71v6.29h-6.29a.65.65,0,1,0,0,1.3h6.29v6.29a.65.65,0,1,0,1.3,0V78.57H140a.65.65,0,1,0,0-1.3h-6.29V71a.65.65,0,0,0-1.3,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M79,130v6.29H72.72a.65.65,0,0,0,0,1.3H79v6.29a.66.66,0,0,0,1.31,0v-6.29h6.29a.65.65,0,0,0,0-1.3H80.32V130A.66.66,0,1,0,79,130Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M115.26,99.16v3.41h-3.42a.36.36,0,0,0,0,.71h3.42v3.42a.35.35,0,0,0,.35.35.35.35,0,0,0,.35-.35v-3.42h3.42a.36.36,0,0,0,0-.71H116V99.16a.34.34,0,0,0-.35-.35A.35.35,0,0,0,115.26,99.16Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M412,66.08A4.94,4.94,0,1,0,416.9,71,4.93,4.93,0,0,0,412,66.08Zm0,8.34A3.41,3.41,0,1,1,415.37,71,3.41,3.41,0,0,1,412,74.42Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M65.28,120.29a4.93,4.93,0,1,0,4.93,4.93A4.94,4.94,0,0,0,65.28,120.29Zm0,8.34a3.41,3.41,0,1,1,3.41-3.41A3.41,3.41,0,0,1,65.28,128.63Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M134.62,94A4.94,4.94,0,1,0,139.55,99,4.94,4.94,0,0,0,134.62,94Zm0,8.34A3.41,3.41,0,1,1,138,99,3.41,3.41,0,0,1,134.62,102.38Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M446.78,157.45a4.94,4.94,0,1,0,4.94,4.93A4.93,4.93,0,0,0,446.78,157.45Zm0,8.34a3.41,3.41,0,1,1,3.41-3.41A3.41,3.41,0,0,1,446.78,165.79Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M377.76,324.47a4.94,4.94,0,1,0,4.93,4.94A4.93,4.93,0,0,0,377.76,324.47Zm0,8.35a3.41,3.41,0,1,1,3.41-3.41A3.41,3.41,0,0,1,377.76,332.82Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M69.56,253.2v6.29H63.27a.65.65,0,0,0,0,1.3h6.29v6.29a.65.65,0,1,0,1.3,0v-6.29h6.29a.65.65,0,1,0,0-1.3H70.86V253.2a.65.65,0,1,0-1.3,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M51.55,212.92V225.1H39.36a1.26,1.26,0,0,0,0,2.52H51.55V239.8a1.26,1.26,0,1,0,2.52,0V227.62H66.25a1.26,1.26,0,0,0,0-2.52H54.07V212.92a1.26,1.26,0,1,0-2.52,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M52.45,281.38v3.42H49a.34.34,0,0,0-.35.35.35.35,0,0,0,.35.35h3.41v3.42a.36.36,0,0,0,.71,0V285.5h3.42a.35.35,0,0,0,.35-.35.35.35,0,0,0-.35-.35H53.16v-3.42a.36.36,0,0,0-.71,0Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M71.81,276.26a4.94,4.94,0,1,0,4.94,4.93A4.93,4.93,0,0,0,71.81,276.26Zm0,8.34a3.41,3.41,0,1,1,3.41-3.41A3.41,3.41,0,0,1,71.81,284.6Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M381.62,113.69a2.47,2.47,0,1,0,2.47,2.47A2.46,2.46,0,0,0,381.62,113.69Zm0,4.17a1.71,1.71,0,1,1,1.71-1.7A1.7,1.7,0,0,1,381.62,117.86Z",
    transform: "translate(-38.1 -66.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M95.17,197.65a2.47,2.47,0,1,0,2.47,2.47A2.47,2.47,0,0,0,95.17,197.65Zm0,4.17a1.71,1.71,0,1,1,1.71-1.7A1.7,1.7,0,0,1,95.17,201.82Z",
    transform: "translate(-38.1 -66.08)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportA);
export default __webpack_public_path__ + "static/media/support-a.b4ac5df65d6d48de96381395799b557a.svg";
export { ForwardRef as ReactComponent };